var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{on:{"click":_vm.onClicked}},[_c('div',{staticClass:"sort",class:{
    asc: _vm.sortPropMatched && _vm.sortType === 'ASC',
    desc: _vm.sortPropMatched && _vm.sortType === 'DESC'
  }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }